import ProductOfferLinkModal from './product-offer-link-modal';

export default ProductOfferLinkModal;
